import axios from "axios";
import { getJwtToken } from "../services/jwt.services";
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API's base URL

const historicalContentService = {
  getJobs: async (pageNumber, pageSize) => {
    const jwtToken = getJwtToken();

    try {
      const apiUrl = `${BASE_URL}/hc/jobs?pageNumber=${pageNumber}&pageSize=${pageSize}`;
      const headers = {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json", // Adjust the content type if needed
      };
      console.log({ apiUrl });
      const response = await axios.get(apiUrl, { headers });
      console.log({
        message: "got data from the back-end",
        data: response.data.result,
      });
      return response.data.result;
    } catch (error) {
      throw error;
    }
  },
  createJob: async (job) => {
    const jwtToken = getJwtToken();
    const jsonPayload = {
      jobName: job.name,
      fromDate: job.fromDate,
      toDate: job.toDate,
      query: job.query,
      dailyLimit: job.dailyLimit,
    };

    try {
      const apiUrl = `${BASE_URL}/hc/jobs`;
      const headers = {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json", // Adjust the content type if needed
      };
      const response = await axios.post(apiUrl, jsonPayload, { headers });
      console.log({
        message: "Created job",
        data: response.data.result,
      });
      return response.data.result;
    } catch (error) {
      throw error;
    }
  },
};

export default historicalContentService;
